export interface HTVLocation {
  id?: string
  customerId?: string
  ancestorLocationIds?: string[]

  name: string
  type: LocationType
  description?: string
  locationId?: string
  tagIds?: string[]
  pmsRoomId?: string

  number?: number

  occupants?: LocationOccupant[]
  cleaningStatus?: CleaningStatus
  occupancyStatus?: OccupancyStatus

  presenceStatus?: boolean
  wakeupAlarmConfigs?: WakeUpAlarmConfig[]
}

export interface UpdateLocationDto {
  id: string
  type: LocationType
  wakeupAlarmConfigs?: WakeUpAlarmConfig[]
}

export enum LocationType {
  HOTEL = 'HOTEL',
  FLOOR = 'FLOOR',
  ROOM = 'ROOM',
  MEETING_ROOM = 'MEETING_ROOM',
  BEDROOM = 'BEDROOM',
  COMMON_AREA = 'COMMON_AREA',
  OTHER = 'OTHER',
}

export interface LocationOccupant {
  salutation?: string
  firstName?: string
  middleName?: string
  lastName?: string
  displayName?: string
  languageCode?: string
}

export interface WakeUpAlarmConfig {
  id?: string
  time: string
  channelId?: string
}

export enum CleaningStatus {
  CLEANED = 'CLEANED',
  DIRTY = 'DIRTY',
  UNKNOWN = 'UNKNOWN',
}

export enum OccupancyStatus {
  UNAVAILABLE = 'UNAVAILABLE',
  AVAILABLE = 'AVAILABLE',
  CHECKED_IN = 'CHECKED_IN',
  CHECKED_OUT = 'CHECKED_OUT',
  UNKNOWN = 'UNKNOWN',
}

export interface Bill {
  currency: string | null
  billOrderedItems: BillOrderedItem[]
}

export interface BillOrderedItem {
  productName: string | null
  quantity?: number
  netPriceInCents?: number
  taxValueInCents?: number
  grossPriceInCents?: number
  date?: string
}
